import { Component, OnInit, OnDestroy } from "@angular/core";
import { SettingService } from "../../_services/setting.service";
import { ProductService } from "../../_services/product.service";
import { UserService } from "../../_services/user.service";
import { Router, NavigationEnd } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material";
import { CommonService } from "../../_services/common.service";
import { CustomFilterService } from "../../_services/custom-filter.service";

@Component({
  selector: 'app-custom-listing',
  templateUrl: './custom-listing.component.html',
  styleUrls: ['./custom-listing.component.css']
})
export class CustomListingComponent implements OnInit {

  public productLists: Array<any> = [];
  public bestSellingProducts: Array<any> = [];
  public lessOrderLimitProducts: Array<any> = [];
  public hideProducts: Array<any> = [];
  public loading = false;
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 50;
  public search: string = "";
  public sortColumnName = "name";
  public sortDirection = "asc";
  public filterProductText: string;
  public filterBrandText: string="";
  public filterStyleText: string="";
  public brand_list: Array<any> = [];
  public style_list: Array<any> = [];
  public showForm = false;
  public viewProductData: any = {};
  public productOptions: any = {};

  constructor(
    private ProductService: ProductService,
    private SettingService: SettingService,
    private UserService: UserService,
    private CommonService: CommonService,
    private router: Router,
    public dialog: MatDialog,
    private _flashMessagesService: FlashMessagesService,
    private CustomFilterService: CustomFilterService
  ) {
    
  }

  ngOnInit() {
    this.getProductOptions();
    this.getProducts();
    this.getBrandList();
    this.getStyleList();
  }  

  ngAfterViewInit() {
    this.CustomFilterService.getAttributesFromCache('brand');
    this.CustomFilterService.getAttributesFromCache('fit');
    this.CustomFilterService.getAttributesFromCache('style');
    this.CustomFilterService.getAttributesFromCache('category');
    this.CustomFilterService.getAttributesFromCache('size');
    this.CustomFilterService.getAttributesFromCache('color');
  }

  productThumb(img) {
    if(img){    
    var re = new RegExp("_fm", "g");
    img = img.replace(re, "_fs");
  }
    return img;
  }

  isEnabled(check_val) {
    return check_val ? true : false;
  }

  updateProduct(id, upd_type, upd_val) {    
    if (upd_type == "best_selling_products") {
      let bestSellingProducts = this.bestSellingProducts.find(x => x === id);
      if (!bestSellingProducts) {
        this.bestSellingProducts.push(id);

        let options = {
          best_selling_products: this.bestSellingProducts
        };
        this.setProductOption(options);
      }
      else {
        this.bestSellingProducts = this.bestSellingProducts.filter(
          item => item !== id
        );
        let options = {
          best_selling_products: this.bestSellingProducts
        };
        this.setProductOption(options);
      }
    }
    if (upd_type == "hide_products") {
      let hideProducts = this.hideProducts.find(x => x === id);     
      if (!hideProducts) {       
        this.hideProducts.push(id);

        let options = {
          hide_products: this.hideProducts
        };
        this.setProductOption(options);
      }
      else {       
        this.hideProducts = this.hideProducts.filter(
          item => item !== id
        );
        let options = {
          hide_products: this.hideProducts
        };
        this.setProductOption(options);
      }
    }

    if (upd_type == "less_order_limit_products") {
      let lessOrderLimitProducts = this.lessOrderLimitProducts.find(
        x => x === id
      );
      if (!lessOrderLimitProducts) {
        this.lessOrderLimitProducts.push(id);
        let options = {
          less_order_limit_products: this.lessOrderLimitProducts
        };
        this.setProductOption(options);
      }
      else {
        this.lessOrderLimitProducts = this.lessOrderLimitProducts.filter(
          item => item !== id
        );
        let options = {
          less_order_limit_products: this.lessOrderLimitProducts
        };
        this.setProductOption(options);
      }
    }
  }

  setProductOption(options) {
    this.SettingService.setSetting(options).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("Details updated successfuly!", {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        console.log("Error =", err);
        this._flashMessagesService.show(err, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }

  getProducts = function () {
    this.loading = true;
    this.productOptions = { limit: this.limit, page: this.page,provider:'custom' };
    if (this.filterProductText) {
      this.productOptions.search = this.filterProductText;
    }
    if (this.filterBrandText) {
      this.productOptions.brand_id = this.filterBrandText;
    }
    if (this.filterStyleText) {
      this.productOptions.style_id = [this.filterStyleText];
    }
    if (this.sortDirection) {
      // this.productOptions.orderBy = this.sortColumnName;
      this.productOptions.direction = this.sortDirection;
    }
    this.productOptions.is_admin=true;
    this.ProductService.getProducts(this.productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.productLists =
            response.data.records.length > 0 ? response.data.records : [];

          this.total = response.data.total;
          this.current_page = response.data.current_page;

          this.limit = response.data.limit;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  };

  getProductOptions = function () {
    let options = ["best_selling_products", "less_order_limit_products","hide_products"];
    this.SettingService.getSetting(options).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            let best_selling_products = response.data.best_selling_products
              ? JSON.parse(response.data.best_selling_products)
              : [];
            let less_order_limit_products = response.data
              .less_order_limit_products
              ? JSON.parse(response.data.less_order_limit_products)
              : [];
              let hide_products=response.data
              .hide_products
              ? JSON.parse(response.data.hide_products)
              : [];
            this.bestSellingProducts = best_selling_products;
            this.lessOrderLimitProducts = less_order_limit_products;
            this.hideProducts=hide_products;            
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  getBrandList = function () {
    let data = {
      id: localStorage.getItem("userID"),
      provider: "custom",
      limit: 500
    };
    this.CommonService.apiService(
      "POST",
      "brands",
      data
    ).subscribe(
      (response: any) => {
        let totalRecords = response.data.records.length;
        if (response.status === true) {
          if (totalRecords > 0) {
            for (var i in response.data.records) {
              this.brand_list.push(response.data.records[i]);
            }
          }
        }
      },
      err => { }
    );
  };

  getStyleList = function () {
    let data = {
      id: localStorage.getItem("userID"),
      provider: "custom",
      limit: 1000
    };
    this.CommonService.apiService(
      "POST",
      "styles",
      data
    ).subscribe(
      (response: any) => {
        let totalRecords = response.data.records.length;
        if (response.status === true) {
          if (totalRecords > 0) {
            for (var i in response.data.records) {
              this.style_list.push(response.data.records[i]);
            }
          }
        }
      },
      err => { }
    );
  };

  filterProduct(): void {
    this.page = 1;
    this.total = 0;
    this.getProducts();
  }

  clearFilterProduct(): void {
    this.filterProductText = "";
    this.page = 1;
    this.total = 0;
    this.getProducts();
  }

  goToPage(n: number): void {
    this.page = n;
    this.getProducts();
  }

  onNext(): void {
    this.page++;
    this.getProducts();
  }

  onPrev(): void {
    this.page--;
    this.getProducts();
  }

  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getProducts();
  }

  toggleForm(loading) {
    if (loading == true) {
      this.viewProductData = {};
      this.ngOnInit();
    }
    this.showForm = !loading;
    return !this.showForm;
  }

  viewProduct(productObj) {
    this.loading = true;
    this.viewProductDetail(productObj);
    this.showForm = true;
  }

  viewProductDetail(productObj) {
    this.productOptions = {};
    if (productObj) {
      this.productOptions.product_id = productObj.product_id;
    }
    this.productOptions.is_admin=true;
    this.ProductService.getProductById(this.productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.viewProductData = response.data;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  showAddProduct(){
    this.router.navigate(['/products/add-product']);
  }
  editProduct(productId){
    this.router.navigate(['/products/add-product',{productId:productId}]);


  }

  openDeleteDialog(id: number): void {   
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this product",
        manageData: { product_id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.product_id) {
        this.deleteProduct(result.product_id);
      }
    });
  }

  deleteProduct = function (product_id) { 
    this.loading = true; 
    this.clientOptions = {};
    this.CommonService.apiService(
      "DELETE",
      "product/delete/"+product_id +"/" +localStorage.getItem("userID") ,
      this.clientOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {         
          this._flashMessagesService.show("Product deleted successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getProducts();
        }
        
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);  

      }
    );
  };

  duplicateProduct = function (product_id) {
    this.loading = true;
    this.options = {
      id: localStorage.getItem("userID"),
      product_id: product_id,
    };
    this.CommonService.apiService(
      "POST",
      "product/duplicate",
      this.options
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this._flashMessagesService.show("Product successfully duplicated!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getProducts();
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);

      }
    );
  };

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/custom-listing/custom-listing.component.ts